import { _ as __rest, a as __assign } from '../../tslib.es6-21effb23.js';
import { c as classNames } from '../../index-29eed6c4.js';
import React__default from 'react';
import { u as useTabsContext } from '../../index-c34a81cb.js';

var styles = {"button":"Tab_button_2a90ec45","disabled":"Tab_disabled_2a90ec45","focus-visible":"Tab_focus-visible_2a90ec45","selected":"Tab_selected_2a90ec45","label":"Tab_label_2a90ec45"};

var Tab = React__default.forwardRef(function Tab(props, ref) {
    var _a;
    var _b, _c, _d, _e, _f, _g;
    var className = props.className, label = props.label, id = props.id, children = props.children, otherProps = __rest(props, ["className", "label", "id", "children"]);
    var tabContext = useTabsContext();
    var onTabChange = (_b = tabContext === null || tabContext === void 0 ? void 0 : tabContext.onTabChange) !== null && _b !== void 0 ? _b : props.onTabChange;
    var isSelected = (_d = (_c = tabContext === null || tabContext === void 0 ? void 0 : tabContext.isSelected) === null || _c === void 0 ? void 0 : _c.call(tabContext, id)) !== null && _d !== void 0 ? _d : props.isSelected;
    var onKeyDown = (_e = tabContext === null || tabContext === void 0 ? void 0 : tabContext.onKeyDown) !== null && _e !== void 0 ? _e : props.onKeyDown;
    var disabled = (_f = tabContext === null || tabContext === void 0 ? void 0 : tabContext.disabled) !== null && _f !== void 0 ? _f : props.disabled;
    var handleClick = function (e) {
        if (onTabChange && id) {
            onTabChange(e, id);
        }
    };
    return (React__default.createElement("button", __assign({ className: classNames(styles.button, (_a = {}, _a[styles.selected] = isSelected, _a[styles.disabled] = disabled, _a), className), id: id, role: "tab", "aria-selected": isSelected, onClick: handleClick, tabIndex: isSelected ? 0 : -1, ref: (_g = tabContext === null || tabContext === void 0 ? void 0 : tabContext.ref) !== null && _g !== void 0 ? _g : ref, disabled: disabled, onKeyDown: onKeyDown }, otherProps),
        React__default.createElement("span", { className: styles.label }, children || label)));
});

export { Tab };
